import React  , { Component } from 'react'
import { withRouter  , Link } from 'react-router-dom'
import axios from "axios" 
import LazyLoad from 'react-lazyload';
import {  HomeSlider,
          HomeTitle,
          Img,
          ResponsiveYouTubeIframe,
          InstagremSliderItem,
          GallerSideBarItem,
          CoverSection     } from '../../../Components/UI/UI'

import { asyncgetWeather, getImgUrl , getUrl, geinstagramData, limitText } from '../../../Utility/Utility'
import SimpleSlider from '../../../Components/SimpleSlider/SimpleSlider';

import Popup from "reactjs-popup";
import Menu from '../../../Components/Menu/Menu'
import Footer from '../../../Components/Footer/Footer'
import Loader  from '../../../Components/Loader/Loader';

import "../Gallery.css"

class GalleryTA extends Component {

  state = {
   
    telAvivWeather : 0,
    instagramData : [],
    instagramDataMobile:[],
    instagramId: null,
    instagramUserImg: null,
    instagramCaption: null ,
    instagramUserName: null ,
    instagramLikes: null ,
    waterTemp : 0,
    jerusalemWeather : 0,
    open: false , 
    isInstaOpen:false,
    openInstagram: false ,
    id : null , 
    isLoader: false,
    ctg : '',
    galleryId:'',
    videoId: '',
    cityName: '',
    stopLoopAt: 0,
    loadingIMg:'loading-insta.gif',
    relatedGalery:[
      {
        title : 'تل-أبيب يافا',
        cityId:'ta'
      },

      {
        title : 'البحر الميّت',
        cityId:'deadsea'
      },

      {
        title : 'القدس',
        cityId:'ja'
      },

      {
        title : 'إيلات',
        cityId:'eilat'
      },
      {
        title : 'النقب',
        cityId:'negev'
      },
      {
        title : 'قيسارية',
        cityId:'caesarea'
      },
      {
        title : 'حيفا',
        cityId:'haifa'
      },
      {
        title : 'أفضل الأطباق، أفضل التجارب',
        cityId:'culinary'
      },
      {
        title : 'زوروا منطقة الجليل',
        cityId:'galilee'
      },
      {
        title : 'الصور التي قمتم بالتقاطها في إسرائيل',
        cityId:'yp'
      }

      ]
     
  } 
  

  OpenLoader = () => {
    this.setState({ isLoader: true });
    console.log('LOADERLOADERLOADER:', this.state.isLoader);
  }

  openModel2 = (id) => {
  this.setState({ isLoader: true });
    // var url ='https://view.activated.co.il/twocities/de/instagram-api.php?ID=' + id; 
  // var url = 'https://www.instagram.com/p/' + id; 
  // window.open(url);

  setTimeout(() => {
    var url = getUrl() + 'instagram-api.php?ID=' + id; 
    var url = 'https://en.citiesbreak.com/instagram-api.php?ID=' + id; 
    // var url = 'https://eu.goisrael.com/instagram-api.php?ID=' + id; 
      console.log('id:',id);

       // alert(url);

      // var url = 'https://www.instagram.com/p/'+id+'/?tagged=takeme2telaviv&__a=1';
      axios.get(url , {}).then(res => {
        var obj = res.data; 

        this.setState({ isLoader:false});

        if( obj == null) {

           var url = 'https://www.instagram.com/p/' + id; 
           window.open(url);

        } else {

          var userinfo = obj.graphql.shortcode_media;
          var likes    = userinfo.edge_media_preview_like.count;
          var username = userinfo.owner.username;
          var caption  = userinfo.edge_media_to_caption.edges[0].node.text;
          var userProfileImg = userinfo.owner.profile_pic_url;

          console.log(username);

          this.setState({ 
              isInstaOpen: true ,
              instagramId: id,
              instagramUserImg: userProfileImg,
              instagramCaption: caption ,
              instagramUserName: username ,
              instagramLikes: likes ,
          });
        }

      });

  },2000);


  };


  openModal = (id , ctg) => {
    this.setState({ 
        open: true ,
        ctg : ctg,
        id : id,
    });
  };
  


  closeModal = () => {
    this.setState({ open: false });
  };

  closeModal2 = () => {
    this.setState({ isInstaOpen: false });
  };
   componentWillMount() {
     this.updateDimensions();
  }
  updateDimensions = () =>{
      var w = window,
        d = document,
        documentElement = d.documentElement,
        body = d.getElementsByTagName('body')[0],
        width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
        // height = w.innerHeight|| documentElement.clientHeight|| body.clientHeight;

        this.setState({width: width});
        
    
  }
  componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.updateDimensions);
  }
  componentDidMount () {
    let galleryId = 'noGalleryId';
    let videoId   = '';
    let cityName   = '';
    let stopLoopAt   = 32;
    console.log(this.props);
    if ( this.props.match.params.galleryId !== undefined ) {
      galleryId = this.props.match.params.galleryId

      if ( galleryId === 'ja' ) {
        videoId = 'V0Acsw3Hf_M';
        stopLoopAt = 32;
        cityName = 'القدس';
      }else if ( galleryId === 'ta' ) {
        videoId = '5nqL-oIC0GA';
        stopLoopAt = 28;
        cityName = 'تل-أبيب يافا';
      }else if ( galleryId === 'deadsea') {
        videoId = 'M627s8TdaB8';
        stopLoopAt = 11 ;
        cityName = 'البحر الميّت';
      }else if ( galleryId === 'eilat') {
        videoId = 'ZdnNT-GDJv4';
        stopLoopAt = 16 ;
        cityName = 'إيلات';
      }else if ( galleryId === 'caesarea') {
        videoId = 'eLZ433_S6HI';
        stopLoopAt = 4 ;
        cityName = 'قيسارية';
      }else if ( galleryId === 'negev') {
        videoId = 'XxWa_MNm5x8';
        stopLoopAt = 17 ;
        cityName = 'النقب';
      }else if ( galleryId === 'haifa') {
        videoId = '3ahATaKkhBk';
        stopLoopAt = 17 ;
        cityName = 'حيفا';
      }else if ( galleryId === 'culinary') {
        videoId = 'JQD9JpMaw9g';
        stopLoopAt = 13 ;
        cityName = 'أفضل الأطباق، أفضل التجارب';
      }else if ( galleryId === 'galilee') {
        videoId = 'ImobrsxsKl8';
        stopLoopAt = 17 ;
        cityName = 'زوروا منطقة الجليل';
      }else if ( galleryId === 'markets') {
        videoId = '2CSCe2WC7Ns';
        stopLoopAt = 13 ;
        cityName = 'الاسواق';
      }else if ( galleryId === 'yp') {
        videoId = 'M627s8TdaB8';
        stopLoopAt = 102 ;
        cityName = 'الصور التي قمتم بالتقاطها في إسرائيل';
      }
    }

    // Save the gallery parameters to state
    this.setState({
      galleryId: galleryId,
      videoId: videoId,
      cityName: cityName,
      stopLoopAt: stopLoopAt
    });

    Promise.all([asyncgetWeather(), geinstagramData()]).then((response) => {
      var weather = response[0];
      const instagramData = response[1];

  
      // console.log(typeof weather);
      // console.log( weather);

      const jerusalemTemperature = '20';
      const deadSeaTemperature = '20';
      const telAvivTemperature = '20';
      const telAvivWaterTemp = '20';

      if (typeof weather !== 'object') {
          // console.log('The weather variable is a string.');
          
          // Find the starting index of the JSON object
          const jsonStartIndex = weather.indexOf('{"jerusalem"');
  
          if (jsonStartIndex !== -1) {
                // Extract the JSON substring
                const jsonString = weather.substring(jsonStartIndex);
    
                // Log the extracted JSON string to verify
                // console.log('Extracted JSON String:', jsonString);
    
                try {
                    const weatherData = JSON.parse(jsonString);
                    // console.log('Parsed Weather Data:', weatherData);
    
                    // Accessing the required temperature values
                    const jerusalemTemperature = weatherData.jerusalem.temperature;
                    const deadSeaTemperature = weatherData.deadsea.temperature;
                    const telAvivTemperature = weatherData.telaviv.temperature;
                    const telAvivWaterTemp = weatherData.telaviv.water_temp;
    
                    // console.log('Jerusalem Temperature:', jerusalemTemperature);
                    // console.log('Dead Sea Temperature:', deadSeaTemperature);
                    // console.log('Tel Aviv Temperature:', telAvivTemperature);
                    // console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
    
                    // Set the state with the extracted values
                    this.setState({
                        instagramData: instagramData.posts,
                        jerusalemWeather: jerusalemTemperature,
                        deadSeaWeather: deadSeaTemperature,
                        telAvivWeather: telAvivTemperature,
                        waterTemp: telAvivWaterTemp,
                    });
    
                } catch (error) {
                    console.error('Error parsing JSON:', error);
                }
            } else {
                console.error('No JSON found in the weather response');
                this.setState({
                  instagramData: instagramData.posts,
                  jerusalemWeather: jerusalemTemperature,
                  deadSeaWeather: deadSeaTemperature,
                  telAvivWeather: telAvivTemperature,
                  waterTemp: telAvivWaterTemp,
              });
            }
      } else {
          // console.log('The weather variable is an object.');
          this.setState({
              instagramData: instagramData.posts,
              jerusalemWeather: weather.jerusalem.temperature,
              deadSeaWeather: weather.deadsea.temperature,
              telAvivWeather: weather.telaviv.temperature,
              waterTemp: weather.jerusalem.water_temp,
          });
      }

  });

  }
  
 
   
  render(){
    
    // let count  = 30;
    let gallery = [];
    for (var i = 1; i <= 32; i++) {
      gallery.push({
        id : i
      });
    };


   
    const sliderSettings = {
      dots: false,
      autoplay: true,
      // lazyLoad: 'ondemand',
      infinite: true,
      lazyLoad: "ondemand",
      cssEase: 'linear',
      slidesToShow: 3,
      slidesToScroll: 3,

      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },

        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
      
    };

    let singleGalleryImg = '';
    let singleGalleryImgMob = '';
    let galleryHtml = '';
    let galleryHtml2 = '';
    let galleryHtml3 = '';
    let galleryHtml4 = '';
    let galleryHtml5 = '';
    let galleryHtml6 = '';
    let galleryHtml7 = '';
    let galleryHtml8 = '';
    let galleryHtml9 = '';
    let galleryHtml10 = '';
    let stopLoopAt = '';
    let finatlHtmlToRender = '';
    let videoId = '';
    let relatedGaleryHtml = null;
    let cover = <CoverSection desktopImg={'/posts/bank/page-gallery/1.jpg'} mobileImg={'/posts/bank/page-gallery/M.jpg'} cssClass={'telaviv'} waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather}/>;
    let cityName = '';
    let cssClass = '';
    let instagramHtml = null;


    let bigImgPath = "gallery/ta/big/" +this.state.id +".jpg";
    if ( this.state.ctg === 'ja' ) {
      bigImgPath = "gallery/ja/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'deadsea' ) {
      bigImgPath = "gallery/deadsea/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'eilat' ) {
      bigImgPath = "gallery/eilat/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'caesarea' ) {
      bigImgPath = "gallery/caesarea/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'negev' ) {
      bigImgPath = "gallery/negev/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'haifa' ) {
      bigImgPath = "gallery/haifa/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'culinary' ) {
      bigImgPath = "gallery/culinary/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'galilee' ) {
      bigImgPath = "gallery/galilee/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'markets' ) {
      bigImgPath = "gallery/markets/big/" +this.state.id +".jpg";
    }
    
    if ( this.props.match.params.galleryId === undefined ) {
          var instagramData = this.state.instagramData; 
          var size = 1;
          // if ( this.state.width < 600 ) {
          //     size = 4;
          // }
          if ( instagramData.length > 0 ) {

            while (instagramData.length > 0) {
                this.state.instagramDataMobile.push(instagramData.splice(0, size));
            }
            
          }

          if ( this.state.instagramDataMobile.length > 0 ) {
            instagramHtml = this.state.instagramDataMobile.map((arr , i)=>{
              return arr.map((o , i) =>  {



                  var imgLink = "instagram/"+o.id+".jpg";
          
                  if ( this.state.width < 600 ) {
                    imgLink = "instagram/Mobile/"+o.id+".jpg";                
                  }
                  return  <div   onClick={ () => {
                                this.openModel2(o.id)
                             }}> <InstagremSliderItem  
                                    title={o.publishBy}
                                    cssClass={'InstagremSliderItem-' + i}
                                    img= {"instagram/"+o.id+".jpg"}
                                    />
                          </div>
                          
              });
            });
            // console.log('instagramHtml2' , instagramHtml2);
            instagramHtml = instagramHtml.map( (o,i) => {
              // console.log(o);
              return <div>{o}</div>;
            });
            
          }

          const currentInstagramLikeUrl = 'https://www.instagram.com/p/'+this.state.instagramId+'/';
          const currentInstagramUrl     = 'https://www.instagram.com/'+this.state.instagramUserName+'/';
          const currentInstagramImgUrl  = "instagram/"+ this.state.instagramId+ ".jpg";

          // alert('currentInstagramImgUrl : ' +currentInstagramImgUrl);
          // alert('currentInstagramUrl : ' +currentInstagramUrl);
          // alert('currentInstagramLikeUrl : ' +currentInstagramLikeUrl);

          galleryHtml = gallery.map( ( o , i )=> {

              console.log(o);
              let cssClass = 'col';
              if (  i % 3 ===  0 ) {
                cssClass += " first ";
              }
              if ( i <= 28 ) {

                 const imgPath =  "gallery/ta/small/" +o.id +".jpg";
                 return <div className={cssClass}  onClick={ () => {
                            this.openModal(o.id , 'ta')
                         }}> 
                          <Img desktopImg={imgPath} />
                        </div>
                
              }
          });

    
          galleryHtml2 = gallery.map( ( o , i )=> {

              let cssClass = 'col';
             if ( i <= 32 ) {

                  const imgPath =  "gallery/ja/small/" +o.id +".jpg";
             return <div className={cssClass}  onClick={ () => {
                        this.openModal(o.id , 'ja');
                     }}> 
                      <Img desktopImg={imgPath} />
                    </div>
                
              }
            
          })

          galleryHtml3 = gallery.map( ( o , i )=> {

            let cssClass = 'col';
            if ( i <= 11 ) {
             
             const imgPath = "gallery/deadsea/small/" +o.id +".jpg";
             return <div className={cssClass}  onClick={ () => {
                        this.openModal(o.id , 'deadsea');
                     }}> 
                      <Img desktopImg={imgPath} />
                    </div>
              }
          })

          galleryHtml4 = gallery.map( ( o , i )=> {

            let cssClass = 'col';
            if ( i <= 16 ) {
             
             const imgPath = "gallery/eilat/small/" +o.id +".jpg";
             return <div className={cssClass}  onClick={ () => {
                        this.openModal(o.id , 'eilat');
                     }}> 
                      <Img desktopImg={imgPath} />
                    </div>
              }
          })
          galleryHtml5 = gallery.map( ( o , i )=> {

            let cssClass = 'col';
            if ( i <= 4 ) {
             
             const imgPath = "gallery/caesarea/small/" +o.id +".jpg";
             return <div className={cssClass}  onClick={ () => {
                        this.openModal(o.id , 'caesarea');
                     }}> 
                      <Img desktopImg={imgPath} />
                    </div>
              }
          })
          galleryHtml6 = gallery.map( ( o , i )=> {

            let cssClass = 'col';
            if ( i <= 17 ) {
             
             const imgPath = "gallery/negev/small/" +o.id +".jpg";
             return <div className={cssClass}  onClick={ () => {
                        this.openModal(o.id , 'negev');
                     }}> 
                      <Img desktopImg={imgPath} />
                    </div>
              }
          })
          galleryHtml7 = gallery.map( ( o , i )=> {

            let cssClass = 'col';
            if ( i <= 5 ) {
             
             const imgPath = "gallery/haifa/small/" +o.id +".jpg";
             return <div className={cssClass}  onClick={ () => {
                        this.openModal(o.id , 'haifa');
                     }}> 
                      <Img desktopImg={imgPath} />
                    </div>
              }
          })

          galleryHtml8 = gallery.map( ( o , i )=> {

            let cssClass = 'col';
            if ( i <= 13 ) {
             
             const imgPath = "gallery/culinary/small/" +o.id +".jpg";
             return <div className={cssClass}  onClick={ () => {
                        this.openModal(o.id , 'culinary');
                     }}> 
                      <Img desktopImg={imgPath} />
                    </div>
              }
          })
          galleryHtml9 = gallery.map( ( o , i )=> {

            let cssClass = 'col';
            if ( i <= 17 ) {
             
             const imgPath = "gallery/galilee/small/" +o.id +".jpg";
             return <div className={cssClass}  onClick={ () => {
                        this.openModal(o.id , 'galilee');
                     }}> 
                      <Img desktopImg={imgPath} />
                    </div>
              }
          })
          galleryHtml10 = gallery.map( ( o , i )=> {

            let cssClass = 'col';
            if ( i <= 13 ) {
             
             const imgPath = "gallery/markets/small/" +o.id +".jpg";
             return <div className={cssClass}  onClick={ () => {
                        this.openModal(o.id , 'markets');
                     }}> 
                      <Img desktopImg={imgPath} />
                    </div>
              }
          })

          finatlHtmlToRender =  <section className="post-data">
          
          <div className="container content-container">
              <div className="col col-100">
            
                


                <div className="inner" id="instagram"> 
                  <HomeTitle>
                    <a href={ getUrl() + '/pages/Gallery/yp'}>
                         الصور التي قمتم بالتقاطها في إسرائيل
                    </a>
                  </HomeTitle>
                  <div className="clear"></div>
                  
                  <div className="clear"></div>

                  <div className="gallery-html-wrapper">
                  <SimpleSlider settings={sliderSettings}>
                  {instagramHtml}
                  </SimpleSlider>
                  </div>
                  <div className="clear"></div>
                  <a className="button show_more"  href={ getUrl() + '/pages/Gallery/yp'}>
                         جميع الصور {'>>'}
                  </a>
                 
                </div>
             

                <LazyLoad height={200} once offset={50}>
                <div className="inner" id="tel-aviv-gallery"> 
                  <HomeTitle>
                     <a href={ getUrl() + '/pages/Gallery/ta'}>
                      تل-أبيب يافا
                     </a>
                  </HomeTitle>
                  <div className="clear"></div>

                  <div className="gallery-html-wrapper">
                    <SimpleSlider settings={sliderSettings}>
                       {galleryHtml}
                    </SimpleSlider>
                  </div>
                  <div className="clear"></div>

                  <a className="button show_more"  href={ getUrl() + '/pages/Gallery/ta'}>
                         جميع الصور {'>>'}
                   </a>
                </div>
                 </LazyLoad>
                

                <LazyLoad height={200} once offset={50}>
                <div className="inner"> 
                  <HomeTitle>
                   <a  href={ getUrl() + '/pages/Gallery/ja'}>
                      القدس
                     </a>
                  </HomeTitle>
                  <div className="clear"></div>
                  
                  <div className="clear"></div>

                  <div className="gallery-html-wrapper">
                  <SimpleSlider settings={sliderSettings}>
                  {galleryHtml2}
                  </SimpleSlider>
                  <div className="clear"></div>
                  <a className="button show_more"  href={ getUrl() + '/pages/Gallery/ja'}>
                      جميع الصور {'>>'}
                   </a>

                  </div>

                </div>
                </LazyLoad>
                <LazyLoad height={200} once offset={50}>
                <div className="inner"> 
                  <HomeTitle>
                   <a  href={ getUrl() + '/pages/Gallery/deadsea'}>
                       البحر الميّت
                     </a>
                     
                  </HomeTitle>
                  <div className="clear"></div>
                  
                  <div className="clear"></div>

                  <div className="gallery-html-wrapper">
                  <SimpleSlider settings={sliderSettings}>
                  {galleryHtml3}
                  </SimpleSlider>
                  </div>
                  <div className="clear"></div>
                  <a className="button show_more"  href={ getUrl() + '/pages/Gallery/deadsea'}>
                         جميع الصور {'>>'}
                     </a>
                </div>
                </LazyLoad>

                <LazyLoad height={200} once offset={50}>
                <div className="inner"> 
                  <HomeTitle>
                   <a  href={ getUrl() + '/pages/Gallery/eilat'}>
                       إيلات
                     </a>
                     
                  </HomeTitle>
                  <div className="clear"></div>

                  <div className="gallery-html-wrapper">
                  <SimpleSlider settings={sliderSettings}>
                  {galleryHtml4}
                  </SimpleSlider>
                  </div>
                  <div className="clear"></div>
                  <a className="button show_more"  href={ getUrl() + '/pages/Gallery/eilat'}>
                         جميع الصور {'>>'}
                     </a>
                </div>
                </LazyLoad>

                <LazyLoad height={200} once offset={50}>
                <div className="inner"> 
                  <HomeTitle>
                   <a  href={ getUrl() + '/pages/Gallery/caesarea'}>
                      قيسارية
                     </a>
                     
                  </HomeTitle>
                  <div className="clear"></div>

                  <div className="gallery-html-wrapper">
                  <SimpleSlider settings={sliderSettings}>
                  {galleryHtml5}
                  </SimpleSlider>
                  </div>
                  <div className="clear"></div>
                  <a className="button show_more"  href={ getUrl() + '/pages/Gallery/caesarea'}>
                         جميع الصور {'>>'}
                     </a>
                </div>
                </LazyLoad>

                <LazyLoad height={200} once offset={50}>
                <div className="inner"> 
                  <HomeTitle>
                   <a  href={ getUrl() + '/pages/Gallery/negev'}>
                      النقب
                     </a>
                     
                  </HomeTitle>
                  <div className="clear"></div>

                  <div className="gallery-html-wrapper">
                  <SimpleSlider settings={sliderSettings}>
                  {galleryHtml6}
                  </SimpleSlider>
                  </div>
                  <div className="clear"></div>
                  <a className="button show_more"  href={ getUrl() + '/pages/Gallery/negev'}>
                         جميع الصور {'>>'}
                  </a>
                </div>
                </LazyLoad>

                <LazyLoad height={200} once offset={50}>
                <div className="inner"> 
                  <HomeTitle>
                   <a  href={ getUrl() + '/pages/Gallery/haifa'}>
                     حيفا
                     </a>
                     
                  </HomeTitle>
                  <div className="clear"></div>

                  <div className="gallery-html-wrapper">
                  <SimpleSlider settings={sliderSettings}>
                  {galleryHtml7}
                  </SimpleSlider>
                  </div>
                  <div className="clear"></div>
                  <a className="button show_more"  href={ getUrl() + '/pages/Gallery/haifa'}>
                         جميع الصور {'>>'}
                     </a>
                </div>
                </LazyLoad>

                <LazyLoad height={200} once offset={50}>
                <div className="inner"> 
                  <HomeTitle>
                   <a  href={ getUrl() + '/pages/Gallery/culinary'}>
                       أفضل الأطباق، أفضل التجارب
                     </a>
                     
                  </HomeTitle>
                  <div className="clear"></div>

                  <div className="gallery-html-wrapper">
                  <SimpleSlider settings={sliderSettings}>
                  {galleryHtml8}
                  </SimpleSlider>
                  </div>
                  <div className="clear"></div>
                  <a className="button show_more"  href={ getUrl() + '/pages/Gallery/culinary'}>
                         جميع الصور {'>>'}
                     </a>
                </div>
                </LazyLoad>

                <LazyLoad height={200} once offset={50}>
                <div className="inner"> 
                  <HomeTitle>
                   <a  href={ getUrl() + '/pages/Gallery/galilee'}>
                       زوروا منطقة الجليل
                     </a>
                     
                  </HomeTitle>
                  <div className="clear"></div>

                  <div className="gallery-html-wrapper">
                  <SimpleSlider settings={sliderSettings}>
                  {galleryHtml9}
                  </SimpleSlider>
                  </div>
                  <div className="clear"></div>
                  <a className="button show_more"  href={ getUrl() + '/pages/Gallery/galilee'}>
                         جميع الصور {'>>'}
                     </a>
                </div>
                </LazyLoad>

                <LazyLoad height={200} once offset={50}>
                <div className="inner"> 
                  <HomeTitle>
                   <a  href={ getUrl() + '/pages/Gallery/markets'}>
                       الاسواق
                     </a>
                     
                  </HomeTitle>
                  <div className="clear"></div>

                  <div className="gallery-html-wrapper">
                  <SimpleSlider settings={sliderSettings}>
                  {galleryHtml10}
                  </SimpleSlider>
                  </div>
                  <div className="clear"></div>
                  <a className="button show_more"  href={ getUrl() + '/pages/Gallery/markets'}>
                         جميع الصور {'>>'}
                     </a>
                </div>
                </LazyLoad>

                

             </div>
             <div className="clear"></div>

          </div>

          <Popup
            open={this.state.isInstaOpen}
            closeOnDocumentClick
            onClose={this.closeModal2}
          >
            <div className="modal">
              <a className="close" onClick={this.closeModal2} >
                &times;
              </a>
              <div className="userImgInstagram">
                <Img desktopImg={currentInstagramImgUrl} />
              </div>
              <div className="user-info-instagram">
                <a target="_blank" href={currentInstagramUrl}>
                  <div className="userProfileImgWrapper">
                    <img src={this.state.instagramUserImg} />
                  </div>
                  @{this.state.instagramUserName} 
                </a>

                <div className="instagramCaption">
                  <p>
                    {(this.state.instagramCaption != null) ? limitText(this.state.instagramCaption , 130) : ''}
                  </p>
                </div>

              </div>

              <div className="clear"></div>
              <a target="_blank" href={currentInstagramLikeUrl}>
              <div className="like-wrapper">
                <Img desktopImg={"like.png"} />
              </div>
              </a>


            </div>
          </Popup>

        </section>;


        

        {/*<Popup open={this.state.open} closeOnDocumentClick onClose={this.closeModal2} >
            <div className="modal">
              <a className="close" onClick={this.closeModal2} >
                &times;
              </a>
              <div className="userImgInstagram">
                <Img desktopImg={currentInstagramImgUrl} />
              </div>
              <div className="user-info-instagram">
                <a target="_blank" href={currentInstagramUrl}>
                  <div className="userProfileImgWrapper">
                    <img src={this.state.instagramUserImg} />
                  </div>
                  @{this.state.instagramUserName} 
                </a>

                <div className="instagramCaption">
                  <p>
                    {(this.state.instagramCaption != null) ? limitText(this.state.instagramCaption , 130) : ''}
                  </p>
                </div>

              </div>

              <div className="clear"></div>
              <a target="_blank" href={currentInstagramLikeUrl}>
              <div className="like-wrapper">
                <Img desktopImg={"like.png"} />
              </div>
              </a>


            </div>
          </Popup>*/}
        



      } else {
        const galleryId = this.state.galleryId;
       
        let imgToShow = '';
        if ( galleryId === 'ta' ) {
          imgToShow = '1.jpg';
        }else if (  galleryId === 'ja' ) {
          imgToShow = '4.jpg';
        }else if (  galleryId === 'deadsea' ) {
          imgToShow = '6.jpg';
        }else if (  galleryId === 'eilat' ) {
          imgToShow = '1.jpg';
        }

          if (galleryId === 'ta' || galleryId === 'deadsea' || galleryId === 'ja'  || galleryId === 'eilat'  || galleryId === 'negev' || galleryId === 'caesarea' || galleryId === 'haifa'  || galleryId === 'galilee' || galleryId === 'culinary' || galleryId === 'markets' ){
              cover = <Img desktopImg={ 'gallery/' + '/ctg/Main/' + galleryId + '.jpg'   } mobileImg ={ 'gallery/' + '/ctg/Mobile/' + galleryId + '.jpg'  } />
              bigImgPath = "gallery/"+galleryId+"/big/" +this.state.id +".jpg";
              
              galleryHtml = gallery.map( ( o , i )=> {
                let cssClass = 'col';
               if ( this.state.stopLoopAt % 3 != 0 && i === this.state.stopLoopAt - 1   ) {
                    // cssClass += ' last';
                    cssClass += ' ';
                }
                if ( i <= this.state.stopLoopAt ) {
                 const imgPath = "gallery/"+galleryId+"/small/" +o.id +".jpg";
                 return <div className={cssClass}  onClick={ () => {
                            this.openModal(o.id , galleryId);
                         }}> 
                          <Img desktopImg={imgPath} />
                        </div>
                  }
              });
          } else if ( galleryId === 'yp' ){
                 // console.log("this.props.match.params.galleryId 10_10 :", this.props.match.params.galleryId);

                cover = <Img desktopImg={ 'gallery/ctg/Main/' + galleryId + '.jpg'   } mobileImg ={ 'gallery/' + 'ctg/Mobile/' + galleryId + '.jpg'  } />
                
               
                galleryHtml = this.state.instagramData.map((o , i)=>{
                   const obj_id = o.id;
                   const obj_publishBy = o.publishBy;
                   // console.log('OOOOO:', o);
                  // return arr.map((o , i) =>  {
                    
                      var imgLink = "instagram/"+o.id+".jpg";          
                      if ( this.state.width < 600 ) {
                        imgLink = "instagram/Mobile/"+o.id+".jpg";                
                      }
                      // console.log('imgLink' , imgLink);
                      return  <div className="ac-wrapper-img-instagram" onClick={() => {
                                      console.log('obj_id:',obj_id);
                                    this.openModel2(obj_id);

                                 }}>
                                    <Img desktopImg={imgLink}/>
                                    <div class="ac-wrapper-publish-by">
                                       <h3 className="ac-publish-by">@{obj_publishBy}</h3>
                                    </div>
                                    
                              </div>
                              
                  // });
                });
                // console.log('instagramHtml2' , instagramHtml2);
                galleryHtml = galleryHtml.map( (o,i) => {
                  return <div>{o}</div>;
                });
          }



        relatedGaleryHtml = this.state.relatedGalery.map((o,i)=>{
          const link = '/pages/Gallery/' + o.cityId;
          if ( o.cityId !== galleryId ) {
            return <GallerSideBarItem title={o.title} 
                                      link={link} 
                                      img={'gallery/' + '/ctg/' + o.cityId + '.jpg' } />
          }
        })

        finatlHtmlToRender = <section className="post-data">
          <div className="clear"></div>
          <div className="container content-container">
              <div className="col col-75">
                
                  <div className="container content-container">
                      <div className="col col-100">
                        <div className="inner"> 
                            <HomeTitle>
                              {this.state.cityName}
                            </HomeTitle>
                            {
                              this.state.galleryId === 'yp'
                              ?
                              null
                              :
                              <ResponsiveYouTubeIframe vidId={this.state.videoId} />
                            }
                          
                          <div className="clear"></div>
                          <div className="gallery-html-wrapper">
                            {galleryHtml}
                          </div>
                          <div className="clear"></div>
                        </div>
                      </div>
                      <div className="clear"></div>
                  </div>
              </div>
              <div className="col col-25 sidebar">
                <div className="inner">
                  <HomeTitle>
                    معرض الصور
                  </HomeTitle>
                  {relatedGaleryHtml}
                  <a class="show_more button" href={ getUrl() + 'Pages/Gallery'}>
                     جميع الصور {'>>'}
                  </a>
                </div>
              </div>
              <div className="clear"></div>
            </div>
        </section>


        
      }



    
    const currentInstagramUrl = 'https://www.instagram.com/'+this.state.instagramUserName+'/';
    const currentInstagramImgUrl  = "instagram/"+ this.state.instagramId+ ".jpg";
    const currentInstagramLikeUrl = 'https://www.instagram.com/p/'+this.state.instagramId+'/';

    return(
      <div className={"page align-center page-Gallery inner-post gallery-" + this.state.galleryId}>
        <Menu />
          {cover}
          {finatlHtmlToRender}
        <Popup
            open={this.state.open}
            closeOnDocumentClick
            onClose={this.closeModal}
          >
            <div className="modal">
              <a className="close" onClick={this.closeModal}>
                &times;
              </a>
              <Img desktopImg={bigImgPath} /> 
            </div>
          </Popup>
          

          {
            this.state.isLoader === true
            ?
            <div className='ac-wrapper-loading'><Loader /></div>
            :
            <Popup open={this.state.isInstaOpen} closeOnDocumentClick onClose={this.closeModal2} >
            <div className="modal">
              <a className="close" onClick={this.closeModal2} >
                &times;
              </a>
              <div className="userImgInstagram">
                <Img desktopImg={currentInstagramImgUrl} />
              </div>
              <div className="user-info-instagram">
                <a target="_blank" href={currentInstagramUrl}>
                  <div className="userProfileImgWrapper">
                    <img src={this.state.instagramUserImg} />
                  </div>
                  @{this.state.instagramUserName} 
                </a>

                <div className="instagramCaption">
                  <p>
                    {(this.state.instagramCaption != null) ? limitText(this.state.instagramCaption , 130) : ''}
                  </p>
                </div>

              </div>

              <div className="clear"></div>
              <a target="_blank" href={currentInstagramLikeUrl}>
              <div className="like-wrapper">
                <Img desktopImg={"like.png"} />
              </div>
              </a>


            </div>
          </Popup>
        }
                                    
          
          
        <Footer />
      </div>
    )
  }

}



export default withRouter(GalleryTA)


// WEBPACK FOOTER //
// ./src/Pages/Gallery/TA/GalleryTA.js